import { render, staticRenderFns } from "./SelectDouble.vue?vue&type=template&id=87549218&scoped=true"
import script from "./SelectDouble.vue?vue&type=script&lang=js"
export * from "./SelectDouble.vue?vue&type=script&lang=js"
import style0 from "./SelectDouble.vue?vue&type=style&index=0&id=87549218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87549218",
  null
  
)

export default component.exports